"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PositionMemorizeWindow;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactIntl = require("react-intl");

var _WindowControls = _interopRequireDefault(require("../../WindowControls/WindowControls"));

var _PositionMemorizeWindowModule = _interopRequireDefault(require("./PositionMemorizeWindow.module.scss"));

var _PositionMemorizeWindow = _interopRequireDefault(require("./PositionMemorizeWindow.i18n"));

var _Button = _interopRequireDefault(require("../../../inputElements/Button/Button"));

var _EButtonType = _interopRequireDefault(require("../../../inputElements/Button/EButtonType"));

var _inputElements = require("../../../inputElements");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function getColAndRowByWindowIndex(index) {
  var tempCol = "RIGHT";
  var tempRow = "1";
  if (index % 2) tempCol = "RIGHT";
  if (index === 3 || index === 4) tempRow = "2";
  if (index === 5 || index === 6) tempRow = "3";
  if (index === 7 || index === 8) tempRow = "4";
  return {
    col: tempCol,
    row: tempRow
  };
}

function PositionMemorizeWindow(_ref) {
  var _ref$memorizedPositio = _ref.memorizedPositions,
      memorizedPositions = _ref$memorizedPositio === void 0 ? [] : _ref$memorizedPositio,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  var renderButtons = (0, _react.useCallback)(function () {
    var nodes = [];

    for (var i = 1; i <= 8; i++) {
      var colRow = getColAndRowByWindowIndex(i);
      var isInEditMode = !!(i % 2); // TODO: maybe skip the one that is in edit mode

      nodes.push( /*#__PURE__*/_react.default.createElement(_Button.default, {
        key: i,
        type: _EButtonType.default.PM,
        onClick: function onClick() {
          return console.error("TODO", memorizedPositions);
        },
        className: (0, _classnames.default)(_PositionMemorizeWindowModule.default[colRow.col], _PositionMemorizeWindowModule.default["row".concat(colRow.row)]),
        isDisabled: isInEditMode
      }, isInEditMode && /*#__PURE__*/_react.default.createElement(_inputElements.Input, {
        type: "text",
        value: i
      }), !isInEditMode && i));
    }

    return nodes;
  }, [memorizedPositions]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_PositionMemorizeWindowModule.default.window, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement(_WindowControls.default, {
    classNameDragHandler: _PositionMemorizeWindowModule.default.dragHandler,
    classNameCloseBtn: _PositionMemorizeWindowModule.default.closeBtn
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _PositionMemorizeWindowModule.default.positions
  }, renderButtons()), /*#__PURE__*/_react.default.createElement("div", {
    className: _PositionMemorizeWindowModule.default.footer
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.PM_SAVE,
    onClick: function onClick() {
      return console.error("TODO", memorizedPositions);
    }
  }, formatMessage(_PositionMemorizeWindow.default.save))));
}